// LIB
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontSize, fontFamily } from '../../Design_System/DesignSystem';

// COMPONENTS
import { Text } from '../atoms/Text';

interface TitleProps {
  title: string;
  subtitle: string;
}

const Title = ({ title, subtitle }: TitleProps) => {
  const [titleSize, setTitleSize] = useState(fontSize.title);

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth < 530;
      setTitleSize(width ? fontSize.smallTitle : fontSize.title);
    }

    window.addEventListener('resize', handleResize);
    handleResize(); // Appel initial pour initialiser la taille de la police de caractères

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Text
        color={colors.tan}
        fontSize={titleSize}
        fontFamily={fontFamily.playfair}
        bold={false}
        justify={false}
      >
        {title}
      </Text>
      <Subtitle
        color={colors.tan}
        fontSize={fontSize.medium}
        fontFamily={fontFamily.tinos}
        bold={false}
        justify={false}
      >
        {subtitle}
      </Subtitle>
    </>
  );
};

const Subtitle = styled(Text)`
  padding-left: 10px;
`;

export default Title;
